import * as React from "react";
import getConfig from "next/config";
import { useBloomreachPageRoutes, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { Container } from "@grandvisionhq/elements";
import { StoresOverviewRoot, StoresOverviewPage } from "@grandvisionhq/stores-v2";
const { publicRuntimeConfig } = getConfig();
const selfUrl = publicRuntimeConfig.selfUrl || "";
const Page = ({ storeGroups }) => {
  const { routes } = useBloomreachPageRoutes();
  const storeLocatorURL = `${selfUrl}${routes.stores}`;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }), /* @__PURE__ */ React.createElement(Container, { className: "stores-v2-layout" }, /* @__PURE__ */ React.createElement(StoresOverviewRoot, { storeLocatorURL, storeGroups })), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }));
};
Page.getInitialProps = async (ctx) => {
  const { req, apolloClient, pathname } = ctx;
  const locale = req?.locale?.toString();
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return {
      statusCode: 500
    };
  }
  try {
    const data = await StoresOverviewPage.getListStoreGroups(apolloClient, locale);
    return { storeGroups: data };
  } catch (err) {
    return {
      statusCode: 500
    };
  }
};
export {
  Page
};
//# sourceMappingURL=store-overview.js.map
